module.exports = __webpack_public_path__ + "img/africa-transec.51073b76.png";